import styled, { css } from "styled-components";

export const Container = styled.div<{ noMargin: boolean }>`
  ${({ noMargin }) =>
    noMargin &&
    css`
      p {
        margin-bottom: 0 !important;
      }
    `}
`;
